import React from 'react';

import { helperText } from './HelperMessage.scss';

interface Props {
  helperMessage: React.ReactNode;
}
const HelperMessage: React.FC<Props> = ({ helperMessage }) =>
  helperMessage ? <p className={helperText}>{helperMessage}</p> : null;

export default HelperMessage;
